export default function striptags(text) {
    if (!text) {
        return '';
    }

    text = text.toString();

    return text.replace(/<\/?[^>]+(>|$)/g, '');
}
